export default __webpack_public_path__ + "static/media/celevoe-obuchenie56.f885e5e9.pdf";